
import { defineComponent, ref, computed } from "vue-demi";
import { SMUser } from "@/store";
import type { TPricingItem } from "@/models/pricing";
import { track } from "@amplitude/analytics-browser";

export default defineComponent({
  name: "SubscriptionBlock",

  props: {
    pricingItem: {
      type: Object as () => TPricingItem | null,
      default: null,
    },
  },

  emits: ["click"],

  setup(props, {emit}) {
    const selectedTabIndex = ref(0);


    function onClick({ plan, tier }: { plan: string, tier: string }) {
      emit("click", { plan, tier });

      track("Clicked 'Continue' on a pricing page [Subscription]", { plan, tier })
    }

    const showActionButton = computed(() => {
      if (SMUser.isBasicSubscriptionActive && props.pricingItem.button.tier === "premium") return true;
      if (SMUser.isBasicSubscriptionActive && props.pricingItem.button.tier === "standard") return true;
      if (SMUser.isBasicSubscriptionActive && props.pricingItem.button.tier === "basic") return false;

      if (SMUser.isStandardSubscriptionActive && props.pricingItem.button.tier === "premium") return true;
      if (SMUser.isStandardSubscriptionActive && props.pricingItem.button.tier === "standard") return false;
      if (SMUser.isStandardSubscriptionActive && props.pricingItem.button.tier === "basic") return false;

      if (SMUser.isPremiumSubscriptionActive) return false;

      return true;
    });

    const isCurrentSubscription = computed(() => {
      if (SMUser.isBasicSubscriptionActive && props.pricingItem.button.tier === "basic") return true;

      if (SMUser.isStandardSubscriptionActive && props.pricingItem.button.tier === "standard") return true;

      if (SMUser.isPremiumSubscriptionActive && props.pricingItem.button.tier === "premium") return true;

      return false;
    });

    return {
      selectedTabIndex,
      onClick,
      showActionButton,
      isCurrentSubscription,
    };
  },
});
